import script from "./PropertySpecialismModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertySpecialismModal.vue?vue&type=script&lang=ts&setup=true"

import "./PropertySpecialismModal.vue?vue&type=style&index=0&id=4d88bea3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d88bea3"]])

export default __exports__